module.exports = __webpack_public_path__ + "static/media/icon_rates.ae1b1349.svg";